import Vue from "vue";
import Router from "vue-router";
import login from "@/components/login";
import index from "@/components/index";

Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: [
        {
            path: "/login",
            name: "login",
            component: login
        },
        {
            path: "/",
            name: "index",
            component: index
        },
        // {
        //     path: "/course/course_view",
        //     name: "course_view",
        //     component: ()=>import('@/components/course/course_view')
        // },

        // { path: '/activiti/process', component: _import('@/components/activiti/process'), name: 'activiti-process', meta: { title: '流程', isTab: true } },
        // { path: '/activiti/detail/:id', component: _import('@/components/activiti/detail'), name: 'activiti-detail', meta: { title: 'detail' } },
        // { path: '/activiti/task', component: _import('@/components/activiti/task'), name: 'activiti-task', meta: { title: '任务', isTab: true } }
    ]
});

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

const whiteList = {
    "/activiti/modeler.html": true
};

router.beforeEach((to, from, next) => {
    // console.log(to.path);
    // console.log(to);
    // console.log(from);
    // console.log(next);

    // 回话管理模式待定，优先使用session，其次考虑拦截器自己实现，不考虑shiro
    const token = sessionStorage.getItem("hwt-token");
    if (to.path === "/login") {
        if (token !== "null" && token !== null) {
            const type = sessionStorage.getItem("type");
            next("/");
        }
        next();
    } else if (whiteList[to.path]) {
        next();
    } else {
        if (token !== "null" && token !== null) {
            // 待验证作用
            next();
        } else {
            next("/login");
        }
    }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js